import store from 'storejs'

const mutations = {
  LOGIN: (state, data) => {
    state.login = data
    store.set('login', data)
  }
}

export default mutations
